import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'echarts'
import 'babel-polyfill';
import './plugins/element.js'
import Install from './plugins/app'
import {tokenCache} from "./lib/cache/Token";
import VChart from "vue-echarts"
import Print from '@mathewparet/vue-print'
import VueClipboard from 'vue-clipboard2';
import {HappyScroll} from 'vue-happy-scroll'

// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);
/*
*
import VChart from "vue-echarts"
import Print from '@mathewparet/vue-print'
* */

Vue.component('v-chart', VChart);
Vue.component('happy-scroll', HappyScroll)
Vue.use(Print);

window.bus = new Vue();
Vue.use(Install);

Log('env', process.env);

//new.html?q=atob(JSON.stringify({token:'',path:''}));


router.beforeEach((to, from, next) => {
    document.title = to.meta.title;
    const token = tokenCache.get();
    if (!!token || to.meta.needLogin === false) {
        next();
    } else {
        next('/login');
    }
});

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
